import Repository from "@/repository";
import {uuid} from "vue-uuid";
import SETTINGS_DEFAULT from "@/modules/workflow/formBuilder/store/formSettings";

const FORM_BUILDER_API = "/formBuilder";
const WORKFLOW_API = "/workflow";
// ----------------------- STATE ------------------------- //
const state = {
    workflow_data: [],
    schema_data: [],
    title: "Untiled Document 2",
    currentPropertyName: "Global",
    currentIndex: -1,
    disableAllCompoents: false,
    modalWindow: false //modal window to show componetnts
};

// ----------------------- GETTERS ----------------------- //
const getters = {
    getCurrentIndex: state => theID => {
        return state.schema_data.findIndex(item => item.id == theID);
    },

    getCurrentID: state => {
        let theIndex = null;
        if (state.currentIndex > -1) {
            theIndex = state.schema_data[state.currentIndex].id;
        }
        return theIndex;
    },

    // get the property
    getCurrentProperty: state => {
        if (state.currentIndex > -1) {
            return state.schema_data.find(
                item => item.id == state.schema_data[state.currentIndex].id
            );
        } else {
            return null;
        }
    },

    // get the data saved in the schema
    getSchemaValue: state => searchID => {
        let schemaItem = {
            value: null
        };

        // somehow i get errors when a field is droped in the dropbox
        schemaItem = state.schema_data.find(data => data.id === searchID);
        return schemaItem.value;
    },

    // get the Schema
    getSchema: state => {
        return state.schema_data;
    },

    // get the Title
    getTitle: state => {
        return state.title;
    },

    //get Description
    getDescription: () => {
        return "Here is some kidogo descritpion";
    }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
    resetFormBuilder(state) {
        state.schema_data = [];
        state.workflow_data = [];
        state.title = "Untiled Document";
        state.currentPropertyName = "Global";
        state.disableAllCompoents = false;
        state.modalWindow = false;
        state.currentIndex = -1;
    },

    setTitle(state, value) {
        state.title = value;
    },

    setOrderNumbers(state) {
        for (var i = 0; i < state.schema_data.length; i++) {
            state.schema_data[i]["order_no"] = i;
        }
    },

    setSchemaValue(state, dataObj) {
        // set value from the field
        let schemaItem;
        schemaItem = state.schema_data.find(data => data.id == dataObj.schema_id);
        schemaItem.value = dataObj.value;
    },

    setCurrentProperty(state, property) {
        // property is an object that consists of a field and a value e.g. {field:'label',value:value}
        state.schema_data[state.currentIndex][property.field] = property.value;
    },

    setCurrentPropertyArrayItem(state, property) {
        // get the array by field e.g table["columns"]
        let theArray = state.schema_data[state.currentIndex][property.field];

        // find the index based on the match field e.g. table["columns"]["id"] == value.id
        let theIndex = theArray.findIndex(
            item => item[property.matchField] == property.item[property.matchField]
        );
        // replace the item in the state
        theArray[theIndex] = property.item;
    },



    setSchema(state, schema) {
        state.schema_data = schema;
    },

    setModalWindow(state, value) {
        state.modalWindow = value;
    },

    setProperties(state, name) {
        state.currentPropertyName = name;
    },

    removePermissionRole(state,item){
        const deleteIndex = state.schema_data[state.currentIndex].permissions[item.mode].findIndex(value => value == item.id)
        if (deleteIndex > -1) {
            state.schema_data[state.currentIndex].permissions[item.mode].splice(deleteIndex,1)
        }
    },

    editFormByID(state, theIndex) {
        state.currentIndex = state.schema_data.findIndex(
            item => item.id == theIndex
        );
        state.currentPropertyName = state.schema_data[state.currentIndex].name;
        state.disableAllCompoents = true;

        // reset all fields
        state.schema_data.forEach(item => (item.value = item.default));
    },

    copyFormByID(state, theIndex) {
        let originIndex;
        // get the Index
        originIndex = state.schema_data.findIndex(item => item.id == theIndex);
        let clone_schema = JSON.parse(
            JSON.stringify(state.schema_data[originIndex])
        );
        clone_schema.id = uuid.v4(); // get a new ID

        // add into array
        state.schema_data.splice(originIndex + 1, 0, clone_schema);
    },

    deleteFormByID(state, theIndex) {
        let tempIndex = state.schema_data.findIndex(item => item.id == theIndex);
        state.schema_data.splice(tempIndex, 1);
    },

    removeField(state,type){
        let tempIndex = state.schema_data.findIndex(item => item.name === type);
        state.schema_data.splice(tempIndex, 1);
    },

    addNewField(state, type) {
        console.log(`addNewField: ${type}`);
        let schemaModified = false;
        switch (type) {
            case "TextField": {
                let dp = SETTINGS_DEFAULT.default_text_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "Integer": {
                let dp = SETTINGS_DEFAULT.default_text_properties();
                dp.type = "number";
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "Float": {
                let dp = SETTINGS_DEFAULT.default_text_properties();
                dp.type = "decimal";
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "EmailField": {
                let dp = SETTINGS_DEFAULT.default_text_properties();
                dp.type = "email";
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "WebField": {
                let dp = SETTINGS_DEFAULT.default_text_properties();
                dp.type = "weblink";
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "Header": {
                let dp = SETTINGS_DEFAULT.default_header_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "TextArea": {
                let dp = SETTINGS_DEFAULT.default_textarea_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "Date": {
                let dp = SETTINGS_DEFAULT.default_date_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Time": {
                let dp = SETTINGS_DEFAULT.default_time_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }



            case "Radio": {
                let dp = SETTINGS_DEFAULT.default_radio_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Checkbox": {
                let dp = SETTINGS_DEFAULT.default_checkbox_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Select": {
                let dp = SETTINGS_DEFAULT.default_select_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Table": {
                let dp = SETTINGS_DEFAULT.default_table_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Attach": {
                let dp = SETTINGS_DEFAULT.default_attach_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Image": {
                let dp = SETTINGS_DEFAULT.default_image_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Signature": {
                let dp = SETTINGS_DEFAULT.default_signature_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Draw": {
                let dp = SETTINGS_DEFAULT.default_draw_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Map": {
                let dp = SETTINGS_DEFAULT.default_map_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }


            case "Switch": {
                let dp = SETTINGS_DEFAULT.default_switch_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "Jahazi": {
                let dp = SETTINGS_DEFAULT.default_jahazi_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "ReadOnly": {
                let dp = SETTINGS_DEFAULT.default_readonly_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "DateTime": {
                let dp = SETTINGS_DEFAULT.default_datetime_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "RouteID": {
                let dp = SETTINGS_DEFAULT.default_route_id_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

            case "RouteName": {
                let dp = SETTINGS_DEFAULT.default_route_name_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "PlaceID": {
                let dp = SETTINGS_DEFAULT.default_place_id_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "PlaceName": {
                let dp = SETTINGS_DEFAULT.default_place_name_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }
            case "Approval": {
                let dp = SETTINGS_DEFAULT.default_approval_properties();
                state.schema_data.push(dp);
                schemaModified = true;
                break;
            }

        }

        // Set the Properties on the Panel
        if (schemaModified) {
            state.currentIndex = state.schema_data.length - 1;
            state.currentPropertyName = state.schema_data[state.currentIndex].name;
            state.disableAllCompoents = true;
        }

        console.log(console.log(state.schema_data));
    },

    loadAllFieldProperties(state, payload) {
        state.schema_data = payload.data;
        state.currentPropertyName = "GlobalTemplateComponents";
        state.disableAllCompoents = false;
        state.currentIndex = -1;
    },

    saveFieldProperties(state) {
        console.log("---------------------");
        state.currentPropertyName = "GlobalTemplateComponents";
        state.disableAllCompoents = false;
        state.currentIndex = -1;

        // reset all fields
        // todo: Removed intializing to default value
        // state.schema_data.forEach(item => (item.value = item.default));
    },

    loadFormBuilderWorkflows(state, payload) {
        state.workflow_data = payload.data;
    },

    loadFormBuilder(state, payload) {
        console.log("***** LOADED FORM BUILDER **********");
        console.log(payload.data.form_builders[0].label);
        state.schema_data = payload.data.form_builders;
    },
    saveFormBuilder(state, payload) {
        state.workflow_data = payload.data;
        state.schema_data = payload.data.form_builders;
    },
    reset(state) {
        state.workflow_data = []
        state.schema_data = []
        state.title = "Untiled Document 2"
        state.currentPropertyName = "Global"
        state.currentIndex = -1
        state.disableAllCompoents = false
        state.modalWindow = false //modal window to show componetnt
    }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
    async loadAllFieldProperties({commit}) {
        try {
            commit(
                "loadAllFieldProperties",
                await Repository.get(`${FORM_BUILDER_API}/`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async saveFieldProperties({state, commit}) {
        try {
            commit(
                "saveFieldProperties",
                await Repository.post(
                    `${FORM_BUILDER_API}/`,
                    state.schema_data[state.currentIndex]
                )
            );
        } catch (error) {
            console.log(error);
        }
    },

    async loadFormBuilderWorkflows({commit}) {
        try {
            commit(
                "loadFormBuilderWorkflows",
                await Repository.get(`${WORKFLOW_API}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async loadFormBuilder({commit}, payload) {
        try {
            commit(
                "loadFormBuilder",
                await Repository.get(`${FORM_BUILDER_API}/${payload}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async saveFormBuilder({state, commit}, payload) {
        try {
            let workflow = {
                id: payload.id,
                name: payload.title,
                description: "some description over here",
                status: "active",
                form_builders: state.schema_data
            };
            commit(
                "saveFormBuilder",
                await Repository.post(`${FORM_BUILDER_API}`, workflow)
            );
        } catch (error) {
            console.log(error);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
